/* Stylesheet */

@keyframes loading-bar {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}

@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.loading_screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.25);
  z-index: 100;
  animation: fade-in 0.5s ease-in;
}

.loading_bar {
  position: absolute;
  top: 0;
  height: 4px;
  width: 100%;
  background: var(--ion-color-text-primary);
  overflow: hidden;
}

.loading_bar::before {
  content: "";
  display: block;
  height: 100%;
  width: 100%;
  background: var(--ion-color-secondary);
  transform: translateX(-100%);
  animation: loading-bar 1.5s infinite ease-in-out;
}
